import styled from "styled-components";
const Container = styled.div`
  margin-top: 20px;
  background-color: white;
`;
const Table = styled.table.attrs({ className: "basic-panel with-shadow" })`
  width: 100%;
  background-color: white;
  tbody td {
    font-size: 8pt;
    padding: 3px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
  thead {
    background-color: #f3f3f3;
  }
  thead th {
    font-size: 8pt;
    text-align: center;
    padding: 3px;
    border-right: 1px solid #ddd;
    background-color: white;
  }
  thead th.product_name {
    background-color: #f3f8ff;
    font-weight: normal;
    vertical-align: middle;
  }
  thead th.bottom_line {
    border-bottom: 1px solid #d2d2d2;
  }
  tbody td.text {
    padding-right: 20px;
  }
  tbody td.counts {
    text-align: center;
  }
  thead th.date {
    text-align: center;
  }
  thead th.day {
    min-width: 40px;
  }
  tbody td.right-edge {
    border-right: 1px solid #d2d2d2 !important;
  }

  thead th.total_col {
    max-width: 80px;
  }
  tbody td.c {
    text-align: center;
  }
`;

const green = "#79ffac";
const amber = "#ffdba2";
const red = "#ffcece";

const ReportCell = styled.td`
  cursor: pointer;
  background-color: ${props =>
    props.fail_count > 0
      ? red
      : props.warning_count > 0
        ? amber
        : props.pass_count > 0
          ? green
          : "#f9f9f9"};
  :hover {
    opacity: 0.7;
  }
`;

const AttributeTd = styled.td`
  color: ${props => (props.value ? "inherit" : "#DDD")};
`;

const ProductNameTd = styled.td`
  min-width: 200px;
  background-color: white;
  border-right: 1px solid #d2d2d2 !important;
`;

const Label = styled.span`
  display: inline;
  padding: 0.1em 0.4em 0.2em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
`;

const FailLabel = styled(Label)`
  background-color: #f05050;
`;
const WarningLabel = styled(Label)`
  background-color: #ff902b;
`;
const PassLabel = styled(Label)`
  background-color: ${green};
  color: #777;
`;
export {
  Container,
  Table,
  ReportCell,
  AttributeTd,
  Label,
  FailLabel,
  WarningLabel,
  PassLabel,
  ProductNameTd
};
